import { render } from "./amount.vue?vue&type=template&id=5441cb05"
import script from "./amount.vue?vue&type=script&lang=js"
export * from "./amount.vue?vue&type=script&lang=js"

import "./amount.vue?vue&type=style&index=0&id=5441cb05&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__